export const Y_MAP_EMBEDDED_MODULES: string[] = [
  'Map',
  'ObjectManager',
  'shape.Rectangle',
  'geometry.pixel.Rectangle',
  'geolocation',
  'hotspot.Layer',
  'GeoObject',
  'templateLayoutFactory',
  'Balloon',
];

export const Y_MAP_ALL_MODULES: string[] = [...Y_MAP_EMBEDDED_MODULES, 'PinsLayer', 'BalloonManager', 'HotspotsLayer'];

// По умолчанию, если не получили настройки карты с бэка, то ставим центр Москвы
export const Y_MAP_DEFAULT_STATE: YMaps.IMapState = {
  center: [55.755381, 37.619044],
  controls: [],
  zoom: 10,
};

export const Y_MAP_DEFAULT_OPTIONS: YMaps.IMapOptions = {
  autoFitToViewport: 'always',
  avoidFractionalZoom: true,
  layerLoadTilesInAction: true,
  restrictMapArea: [
    [41.1859, 19.6389],
    [81.8569, -168.9978],
  ],
  suppressMapOpenBlock: true,
  yandexMapAutoSwitch: false,
  yandexMapDisablePoiInteractivity: true,
};

export const TILE_SIZE = 256;
// Пины, у которых есть тултип
export const PIN_RADIUS_WITH_BALLOON = 6;
export const PIN_BORDER_WIDTH_WITH_BALLOON = 2;
export const PIN_RADIUS_ACTIVE_WITH_BALLOON = 3;
export const PIN_BORDER_WIDTH_ACTIVE_WITH_BALLOON = 0;

// Пины без тултипов
export const PIN_RADIUS_REGULAR = 7;
export const PIN_RADIUS_CLICKABLE = 8;
export const PIN_RADIUS_CLICKABLE_WITH_COUNT = 11;
export const PIN_BORDER_WIDTH_REGULAR = 1;
export const PIN_BORDER_WIDTH_CLICKABLE = 2;
export const MAX_PIN_RADIUS = PIN_RADIUS_CLICKABLE_WITH_COUNT;

export const PIN_SHADOW_X_RADIUS = 8;
export const PIN_SHADOW_Y_RADIUS = 3.5;
export const PIN_SHADOW_Y_OFFSET = 4.5;

// Сдвиг балуна по вертикали относительно пина
export const BALLOON_OFFSET_TOP = 4;

// Используются, когда пин активен, и нужно его показать над другими пинами
export const INACTIVE_PIN_BALLOON_Z_INDEX = 1;
export const ACTIVE_PIN_BALLOON_Z_INDEX = INACTIVE_PIN_BALLOON_Z_INDEX + 1;

export const MAP_ZOOMING_OPTIONS: YMaps.ISetCenterOptions = {
  duration: 500,
  timingFunction: 'ease-in-out',
};
